import React from 'react';
import InfoBorder from 'assests/icons/info-border.icon';
import classNames from 'classnames';
import './info-box.less';

const InfoBox = (props) => {
  return (
    <div
      className={classNames('info-box', props.compClass, {
        warning: props.type === 'warning',
      })}
    >
      {props.type === 'warning' ? (
        <div className="info-box__icon">
          <InfoBorder />
        </div>
      ) : null}
      {props.content &&
        <div className="info-box__content" >{props.content}</div>
      }
      {props.htmlContent &&
        <div className="info-box__content" dangerouslySetInnerHTML={{__html: props.htmlContent}}></div>
      }
      
    </div>
  );
};

export default InfoBox;
